const ShowPassIcon = ({ color }) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="26"
      viewBox="0 0 512.000000 512.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill={color}
        stroke="none"
      >
        <path
          d="M2350 4154 c-592 -56 -1097 -263 -1574 -647 -135 -108 -391 -366
            -500 -502 -118 -149 -264 -368 -272 -410 -3 -19 -3 -51 0 -70 8 -42 154 -261
            272 -410 109 -136 365 -394 500 -502 434 -349 892 -552 1419 -630 168 -24 562
            -24 730 0 348 51 660 154 950 314 446 245 851 621 1145 1061 130 195 130 209
            0 404 -128 192 -243 332 -420 509 -480 483 -1020 765 -1640 860 -131 20 -496
            33 -610 23z m462 -329 c462 -49 914 -241 1307 -554 207 -166 461 -435 600
            -635 l52 -76 -41 -60 c-172 -254 -471 -557 -735 -746 -491 -352 -1081 -518
            -1651 -464 -577 55 -1103 310 -1568 760 -127 123 -291 313 -375 435 l-52 75
            50 73 c98 141 187 244 355 413 242 241 462 402 742 542 408 204 861 286 1316
            237z"
        />
        <path
          d="M2393 3505 c-201 -36 -365 -124 -513 -274 -129 -130 -212 -278 -257
            -457 -24 -95 -24 -333 0 -428 45 -179 128 -327 257 -457 177 -180 385 -273
            635 -286 277 -14 519 81 720 282 137 137 216 276 262 461 24 95 24 333 0 428
            -25 99 -72 210 -125 296 -62 102 -206 243 -311 308 -196 120 -445 168 -668
            127z m302 -320 c216 -45 409 -223 478 -440 31 -99 31 -271 0 -370 -63 -199
            -229 -365 -428 -428 -57 -18 -93 -22 -190 -22 -104 1 -130 5 -193 27 -105 38
            -176 83 -257 163 -247 246 -245 645 5 895 155 156 370 220 585 175z"
        />
      </g>
    </svg>
  );
};

export default ShowPassIcon;
